import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from 'shared/ui/error-boundary';
import CardsPage from 'pages/cards.page';
import CardDetailPage from './CardDetailPage';
import CardReplacementRequestDetailPage from './CardReplacementRequestDetailPage';
const CardRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { path: ":cardId/replacement/:requestId", element: _jsx(ErrorBoundary, { children: _jsx(CardReplacementRequestDetailPage, {}) }) }), _jsx(Route, { path: ":id", element: _jsx(ErrorBoundary, { children: _jsx(CardDetailPage, {}) }) }), _jsx(Route, { path: "*", element: _jsx(ErrorBoundary, { children: _jsx(CardsPage, {}) }) })] }));
export const CMS_NAV_ITEM = {
    id: 'cards',
    pathSegment: 'cards',
    labelKey: 'form.card',
    icon: 'pi pi-credit-card',
    authorityKeys: ['ADMIN'],
    RoutesComponent: CardRoutes,
};
export default CardRoutes;
